import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Breadcrumb } from '@retailer-platform/shared-components'
import { PageHeader } from '@retailer-platform/shared-components'
import { Breadcrumbs } from '@retailer-platform/shared-components'
import { useDomainScopedPathname } from 'domains/products/utils/domain/routing'
import { ProductsBreadcrumbs } from 'domains/products/components/breadcrumbs/ProductsBreadcrumbs'

interface ProductsEditImagesHeaderProps {
  productName: string
}

export const ProductsEditImagesHeader: FunctionComponent<ProductsEditImagesHeaderProps> = ({
  productName,
}) => {
  const detailsPath = useDomainScopedPathname('products-view-details')
  return (
    <PageHeader
      title={
        <ProductsBreadcrumbs>
          <Breadcrumbs>
            <Breadcrumb path={detailsPath}>{productName}</Breadcrumb>
            <Breadcrumb>
              <FormattedMessage id={'productsDomain.view.header.editImages'} />
            </Breadcrumb>
          </Breadcrumbs>
        </ProductsBreadcrumbs>
      }
    />
  )
}
